import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
import { GlobalSearchResponse } from "../../../domain/models/global-search.model";
import { GlobalSearchRepository } from "../../../domain/repositories/global-search.repositories";

@Injectable()
export class GlobalSearchRepositoryImpl extends GlobalSearchRepository {
  private BASE_URL = environment.apiUrl;

  constructor(private http: HttpClient) {
    super();
  }

  override search(query: string): Observable<GlobalSearchResponse> {
    // throw new Error("Method not implemented.");
    return this.http.get<GlobalSearchResponse>(
      `${this.BASE_URL}/globalSearch/search`,
      { params: { searchTerm: query } },
    );
  }

  override searchByType(type: string, query: string) {
    if (type == "opportunity") {
      type = "opportunitie";
    }
    return this.http
      .get<GlobalSearchResponse>(
        `${this.BASE_URL}/globalSearch/search/${type}s`,
        { params: { searchTerm: query } },
      )
      .pipe(map((gsr) => gsr.search[0].records));
  }
}
